{
  "info": "Informacije",
  "negative": "Napaka",
  "notice": "Opozorilo",
  "positive": "Uspešno"
}
